import processElementChildren from '../../utils/processElementChildren';
import { TRANSITION_DELAYS } from '../../constants';

const motionWrapperComponents = [
	{
		selector: '.c-image:not(.c-image--full-width)',
		callback: (element) => {
			processElementChildren(element, '.c-image__img', TRANSITION_DELAYS.md);
			processElementChildren(element, '.c-image__caption', TRANSITION_DELAYS.lg);
		},
	},
	{
		selector: '.c-image--full-width',
		// changed to zero delay for full image width on hero banner
		callback: (element) => {
			processElementChildren(element, '.c-image__img', 0);
		},
	},
	{
		selector: '.c-carousel > .container',
	},
	{
		selector: '.c-careers > .container',
	},
	{
		selector: '.c-video > .container',
	},
	{
		selector: '.c-hero:not(.c-hero--text)',
		callback: element => processElementChildren(element, '.container'),
	},
	// {
	// 	selector: '.c-hero--text',
	// },
	{
		selector: '.c-quote > .container',
	},
	{
		selector: '.c-quote-carousel > .container',
	},
	{
		selector: '.c-editorial > .container',
	},
	{
		selector: '.c-bullet-list > .container',
	},
	{
		selector: '.c-article-author',
		callback: (element, index) => {
			processElementChildren(element, '.container');
			processElementChildren(element, '.c-article-author__img', index + 1 * TRANSITION_DELAYS.md);
		},
	},
	{
		selector: '.c-event-intro-block > .container',
	},
	{
		selector: '.c-featured-content',
		callback: (element, index) => {
			processElementChildren(element, '.container', index + 1 * TRANSITION_DELAYS.md);
			processElementChildren(element, '.c-featured-content__image', index + 1 * TRANSITION_DELAYS.md);
		},
	},
	{
		selector: '.c-case-study-promo',
		callback: (element, index) => {
			processElementChildren(element, '.container', index + 1 * TRANSITION_DELAYS.md);
			processElementChildren(element, '.c-case-study-promo__item');
		},
	},
	{
		selector: '.c-device-image',
		callback: (element, index) => {
			processElementChildren(element, '.c-device-image__picture', index + 1 * TRANSITION_DELAYS.md);
			processElementChildren(element, '.c-device-image__img', index + 1 * TRANSITION_DELAYS.md);
		},
	},
	{
		selector: '.c-info-block',
		callback: (element) => {
			processElementChildren(element, '.c-info-block > .container');
			processElementChildren(element, '.c-info-block__item');
			processElementChildren(element, '.c-info-block__image', TRANSITION_DELAYS.md);
		},
	},
	{
		callback: element => processElementChildren(element, '.c-article-listing__item'),
	},
	{
		selector: '.c-location-block',
		callback: element => processElementChildren(element, '.c-location-block__item'),
	},
	{
		selector: '.c-image-grid',
		callback: (element) => {
			processElementChildren(element, '.c-image-grid__item');
			processElementChildren(element, '.c-image-grid__image img, .c-person-block__image img');
		},
	},
	{
		selector: '.c-generic-hero',
		callback: (element) => {
			processElementChildren(element, '.c-generic-hero__content-wrapper', TRANSITION_DELAYS.md);
			processElementChildren(element, '.c-generic-hero__img', 0);
		},
	},
	{
		selector: '.c-related-articles',
		callback: (element, index) => {
			processElementChildren(element, '.c-related-articles > .container');
			processElementChildren(element, '.c-related-articles__item');
			processElementChildren(element, '.c-related-articles__item-image', index + 1 * TRANSITION_DELAYS.md);
		},
	},
	{
		selector: '.c-image-row',
		callback: (element, index) => {
			processElementChildren(element, '.c-image-row__item');
			processElementChildren(element, '.c-content-block__image img', index + 1 * TRANSITION_DELAYS.md);
		},
	},
	{
		selector: '.c-stats',
		callback: element => processElementChildren(element, '.c-stats__item'),
	}
];

export default motionWrapperComponents;
